import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from '../services/api';
import {
    FileRequest,
    FileUploadUrlRequest } from '../types/attachments';

export const SLICE_NAME = 'attachment';

export const ACTION_TYPES = {
    GET_FILE_UPLOAD_URL: `${SLICE_NAME}/getFileUploadUrl`,
    GET_FILE_VIEW_URL: `${SLICE_NAME}/getFileViewUrl`,
    SCAN_FILE: `${SLICE_NAME}/scanFile`
};

export const getUploadUrl = createAsyncThunk(
    ACTION_TYPES.GET_FILE_UPLOAD_URL,
    async (options: FileUploadUrlRequest, { rejectWithValue }) => {
        try {
            const response = await api.getFileUploadUrl(options.fileName, options.fileType, options.workId, options.isBug);
            return { url: response.url, fileId: response.fileId };
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getViewUrl = createAsyncThunk(
    ACTION_TYPES.GET_FILE_VIEW_URL,
    async (options: FileRequest, { rejectWithValue }) => {
        try {
            const response = await api.getFileViewUrl(options.fileId);
            return response.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const scanFile = createAsyncThunk(
    ACTION_TYPES.SCAN_FILE,
    async (options: FileRequest, { rejectWithValue }) => {
        try {
            const response = await api.scanUserAttachment(options.fileId);
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getMessageUploadUrl = createAsyncThunk(
    'attachment/getMessageUploadUrl',
    async (
        options: { fileName: string; fileType: string; conversationId: number },
        { rejectWithValue }
    ) => {
        try {
            const response = await api.getMessageFileUploadUrl(
                options.fileName,
                options.fileType,
                options.conversationId
            );
            return { url: response.url, fileId: response.attachmentId };
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getMessageViewUrl = createAsyncThunk(
    'attachment/getMessageViewUrl',
    async (options: { attachmentId: number }, { rejectWithValue }) => {
        try {
            return await api.getMessageFileViewUrl(options.attachmentId);
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const scanMessageFile = createAsyncThunk(
    'attachment/scanMessageFile',
    async (options: { attachmentId: number }, { rejectWithValue }) => {
        try {
            return await api.scanMessageAttachment(options.attachmentId);
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
